import React, { memo } from 'react'
import { Button, Flex, Modal, Typography, theme } from 'antd'
import { CloudUploadOutlined, ExclamationCircleFilled, SyncOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

const { Title, Text } = Typography

/**
 * Modal blokir tutup shift (Mode Zero-Loading): antrean sinkron belum tuntas — perlu
 * tindakan (gagal/terblokir) & sedang dikirim — dengan jalan pintas ke Pusat Sinkronisasi.
 * Sama dengan kledopos-mobile `PendingSyncBlockModal`.
 */
const PendingSyncBlockModal = ({ open, counts, onOpenSyncCenter, onClose }) => {
  const { formatMessage } = useIntl()
  const { token } = theme.useToken()
  const action = (counts?.failed ?? 0) + (counts?.blocked ?? 0)
  const progress = (counts?.pending ?? 0) + (counts?.sent ?? 0)

  const rows = [
    {
      key: 'action',
      icon: <ExclamationCircleFilled />,
      color: token.colorError,
      bg: token.colorErrorBg,
      label: formatMessage({ id: 'pos.sync_center.close_shift.action' }),
      value: action,
    },
    {
      key: 'progress',
      icon: <CloudUploadOutlined />,
      color: token.colorPrimary,
      bg: token.colorPrimaryBg,
      label: formatMessage({ id: 'pos.sync_center.close_shift.progress' }),
      value: progress,
    },
  ].filter((row) => row.value > 0)

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={440} centered destroyOnHidden>
      <Flex vertical align="center" style={{ textAlign: 'center', paddingTop: 8 }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: token.colorWarningBg,
            color: token.colorWarning,
            fontSize: 30,
            marginBottom: 16,
          }}
        >
          <SyncOutlined />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          {formatMessage({ id: 'pos.sync_center.close_shift.title' })}
        </Title>
        <Text type="secondary" style={{ marginTop: 6 }}>
          {formatMessage({ id: 'pos.sync_center.close_shift.message' })}
        </Text>
      </Flex>
      <Flex gap={12} style={{ marginTop: 20 }}>
        {rows.map((row) => (
          <Flex
            key={row.key}
            align="center"
            gap={12}
            style={{
              flex: 1,
              padding: '12px 14px',
              borderRadius: 12,
              background: row.bg,
              color: row.color,
            }}
          >
            <span style={{ fontSize: 20 }}>{row.icon}</span>
            <span style={{ textAlign: 'left' }}>
              <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>{row.value}</div>
              <div style={{ fontSize: 12, color: token.colorTextSecondary }}>{row.label}</div>
            </span>
          </Flex>
        ))}
      </Flex>
      <Button
        type="primary"
        block
        size="large"
        style={{ marginTop: 20 }}
        onClick={onOpenSyncCenter}
      >
        {formatMessage({ id: 'pos.sync_center.close_shift.open' })}
      </Button>
      <Button block type="text" style={{ marginTop: 8 }} onClick={onClose}>
        {formatMessage({ id: 'pos.sync_center.close_shift.later' })}
      </Button>
    </Modal>
  )
}

export default memo(PendingSyncBlockModal)
